import React from 'react'
import LabelModal from './LabelModal'

const DeleteLabelProductModal = ({ onConfirm, onCancel }) => {

    const title = <>Eliminar producto <br /> del label público</>;
    const description = <>Este cambio afectará a todas las personas <br /> que vean y usen este label</>;
    const subTitle = "¿Estás seguro de realizar esta acción?";
    const confirmAction = "Si, eliminar";

    return <LabelModal
        title={title}
        description={description}
        subtitle={subTitle}
        confirmAction={confirmAction}
        onCancel={onCancel}
        onConfirm={onConfirm}
    />
}

export default DeleteLabelProductModal;